import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';

import Main from './Main';
import Contact from './Contact';
import Services from './Services';
import Culture from './Culture';
import Insights from './Insights';
import Community from './Community';
import JoinTeam from './JoinTeam';
import ConnectContact from './ConnectContact';
import ServiceRequest from './ServiceRequest';
import IdeaInspiration from './IdeaInspiration';
import IdeaRegistration from './IdeaRegistration';
import InputCode from './InputCode';
import UploadResume from './UploadResume';
import ThankYou from './ThankYou';
import EmailAdded from './EmailAdded';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
        <Router>
          <Routes>
            <Route path="/" element={<Main/>} />
            <Route path="/contact" element={<Contact/>} />
            <Route path="/services" element={<Services/>} />
            <Route path="/culture" element={<Culture/>} />
            <Route path="/insights/:blogref?" element={<Insights/>} />
            <Route path="/community" element={<Community/>} />
            <Route path="/jointeam" element={<JoinTeam/>} />
            <Route path="/connectcontact" element={<ConnectContact/>} />
            <Route path="/servicerequest" element={<ServiceRequest/>} />
            <Route path="/inspiration" element={<IdeaInspiration/>} />
            <Route path="/registration" element={<IdeaRegistration/>} />
            <Route path="/inputcode/:table" element={<InputCode/>} />
            <Route path="/uploadresume" element={<UploadResume/>} />
            <Route path="/thankyou" element={<ThankYou/>} />
            <Route path="/emailadded" element={<EmailAdded/>} />
          </Routes>
        </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
